var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/StreetView
*/
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import VControlButton from '../view/VControlButton';
import { HTTP_PROTOCOL, IMG } from '../globals';
import VStreetView, { EventType } from '../view/VStreetView';
import Marker from '../Marker';
import Icon from '../Icon';
import LonLat from '../LonLat';
/* eslint-disable no-undef */
/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const control = new cercaliagl.control.Traffic();
 * ```
 * <br/>
 * This control allow to display real traffic and forecast traffic.
 * <br/>
 * - In real traffic most roads display linestrings over them. In the bottom right dialog you can see the legend.
 *   Traffic affectations like accidents, network managements are displayed too.
 * - In forecast traffic you can adjust the date and the forecast time.
 */
var StreetView = /** @class */ (function (_super) {
    __extends(StreetView, _super);
    /**
     * @constructor
     * @api
     */
    function StreetView(optOptions) {
        var _this = this;
        var options = optOptions || {};
        var className = options.className !== undefined ? options.className : 'v-streetview';
        var positionClass = options.position !== undefined ? options.position : 'bottom-right';
        var controlButton = new VControlButton('Street_view_icon', ['path1', 'path2', 'path3', 'path4', 'path5', 'path6', 'path7']);
        var element = controlButton.getElement();
        element.className = "v-control-button ".concat(className, " ").concat(positionClass);
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.StreetView',
            name: MapControls.STREETVIEW,
        }) || this;
        /**
       * @private
       * @type {string|null}
       */
        _this.apiKey_ = options.apiKey ? options.apiKey : null;
        /**
       * @private
       * @type {number}
       */
        _this.width_ = options.width ? options.width : 600;
        /**
       * @private
       * @type {number}
       */
        _this.height_ = options.height ? options.height : 480;
        /**
       * @private
       * @type {string}
       */
        _this.gmapsClient_ = 'gme-consultoriatecnica';
        /**
       * @private
       * @type {string}
       */
        _this.gmapsChannel_ = 'd2ee3qku';
        /**
       * @private
       * @type {string}
       */
        _this.gmapsApiKey_ = 'AIzaSyCMO8HKcgFilFXYib35MU0UOwmLhiuPnQY';
        /**
       * Image StreetView On
       * @private
       * @type {string}
       */
        _this.imgStreetViewOn_ = "".concat(IMG, "/cercalia-marker-streetview-enabled.png");
        /**
       * Image StreetView Off
       * @private
       * @type {string}
       */
        _this.imgStreetViewOff_ = "".concat(IMG, "/cercalia-marker-streetview-disabled.png");
        /**
       * @private
       * @type {Marker}
       */
        _this.streetViewMarker_ = null;
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled_ = false;
        /**
       * @private
       * @type {google.maps.StreetViewPanorama}
       */
        _this.streetViewPanorama_ = null;
        /**
       * @private
       * @type {google.maps.StreetViewService}
       */
        _this.streetviewService_ = null;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.element_ = element;
        /**
       * @private
       * @type {VStreetView}
       */
        _this.popup_ = new VStreetView({ width: _this.width_, height: _this.height_ });
        _this.popup_.on(EventType.CLOSE, _this.disable.bind(_this));
        /**
       * @private
       * @type {boolean}
       */
        _this.dragging_ = false;
        /**
       * @private
       * @type {boolean}
       */
        _this.loaded_ = false;
        /**
       * @private
       * @type {boolean}
       */
        _this.enableWhenLoad_ = false;
        /**
       * @private
       * @type {boolean}
       */
        _this.loaded_ = false;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    StreetView.prototype.initialize_ = function () {
        var _this = this;
        var _a;
        if (typeof google === 'undefined') {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            var apiUrl = "".concat(HTTP_PROTOCOL, "//maps.googleapis.com/maps/api/js?")
                + "key=".concat((_a = this.apiKey_) !== null && _a !== void 0 ? _a : this.gmapsApiKey_);
            script.src = apiUrl;
            document.body.appendChild(script);
            script.onload = function () {
                _this.loaded_ = true;
                if (_this.enableWhenLoad_) {
                    _this.enable();
                }
            };
        }
        this.controlButton_.setTooltip(i18n('tooltipStreetView'));
        this.element_.addEventListener('click', this.handleClick_.bind(this));
    };
    /**
     * @private
     */
    StreetView.prototype.handleClick_ = function () {
        if (!this.enabled_) {
            this.enable();
        }
        else {
            this.disable();
        }
    };
    /**
   * Set position of street view panorama.
   * @param {LonLat} position Position.
   * @api
   */
    StreetView.prototype.setPosition = function (position) {
        var latLng = new google.maps.LatLng(position.getLat(), position.getLon());
        this.setLocationAndPOV_(latLng);
    };
    /**
   * Enable StreetView control
     * @override
     * @api
     */
    StreetView.prototype.enable = function () {
        if (!this.loaded_) {
            this.enableWhenLoad_ = true;
            return;
        }
        var center = this.getCercaliaMap().getCenter();
        // this.initializeDialog_();
        this.initializeStreetViewPanorama_();
        if (center) {
            this.setPosition(center);
        }
        if (!this.streetViewMarker_) {
            this.createStreetViewMarker_();
        }
        this.enabled_ = true;
        this.controlButton_.enable();
        if (!this.popup_.getElement().closest('body')) {
            var container = this.getMap().getContainer();
            this.popup_.appendTo(container);
        }
        this.popup_.show();
    };
    /**
   * @private
   */
    StreetView.prototype.initializeStreetViewPanorama_ = function () {
        // Si no estaba inicializado el StreetView
        if (this.streetViewPanorama_) {
            return;
        }
        var bodyPopupDiv = this.popup_.getElement();
        this.streetviewService_ = new google.maps.StreetViewService();
        this.streetViewPanorama_ = new google.maps.StreetViewPanorama(bodyPopupDiv, {
            position: null,
            addressControl: true,
            addressControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER,
                style: {
                    fontWeight: 'bold',
                    backgroundColor: '#191970',
                    color: '#A9203E',
                },
            },
            linksControl: true,
            navigationControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT,
                /* style: google.maps.NavigationControlStyle.SMALL */
            },
            enableCloseButton: false,
            pov: {
                heading: 120,
                pitch: 0,
                zoom: 2,
            },
        });
        this.streetViewPanorama_.addListener('position_changed', this.handlePositionChanged_.bind(this));
    };
    StreetView.prototype.createStreetViewMarker_ = function (optPosition) {
        var _this = this;
        var cercaliaMap = this.getCercaliaMap();
        var center = optPosition !== null && optPosition !== void 0 ? optPosition : cercaliaMap.getCenter();
        this.streetViewMarker_ = new Marker({
            icon: new Icon({
                src: this.imgStreetViewOn_,
            }),
            position: center,
            draggable: true,
            zIndex: 99999,
            onDragStart: function () { _this.dragging_ = true; },
            onDragEnd: function () { _this.pointerupFunction_(); },
        });
        this.getCercaliaMap().addMarker(this.streetViewMarker_);
    };
    /**
   * @private
   */
    StreetView.prototype.removeStreetViewMarker_ = function () {
        this.getCercaliaMap().removeMarker(this.streetViewMarker_);
        this.streetViewMarker_ = null;
    };
    /**
   * @private
   */
    StreetView.prototype.handlePositionChanged_ = function () {
        var lonLat = this.streetViewPanorama_.getPosition();
        var position = new LonLat(lonLat.lng(), lonLat.lat());
        this.removeStreetViewMarker_();
        this.createStreetViewMarker_(position);
    };
    StreetView.prototype.pointerupFunction_ = function () {
        if (this.dragging_) {
            this.dragging_ = false;
            var position = this.streetViewMarker_.getPosition();
            var latLngGoogle = new google.maps.LatLng(position.getLat(), position.getLon());
            this.setLocationAndPOV_(latLngGoogle);
        }
    };
    /**
   * @private
   * @param {google.maps.LatLng} latLng Position google object class.
   */
    StreetView.prototype.setLocationAndPOV_ = function (latLng) {
        var _this = this;
        var panoramaLocation = {
            location: latLng,
            radius: 50,
        };
        this.streetviewService_.getPanorama(panoramaLocation, function (data) {
            var icon;
            if (data) {
                _this.streetViewPanorama_.setPano(data.location.pano);
                _this.streetViewPanorama_.setPov(/** @type {google.maps.StreetViewPov} */ ({
                    heading: 270,
                    pitch: 0,
                    zoom: 2,
                }));
                _this.streetViewPanorama_.setVisible(true);
                icon = _this.imgStreetViewOn_;
            }
            else {
                _this.streetViewPanorama_.setVisible(false);
                icon = _this.imgStreetViewOff_;
            }
            _this.streetViewMarker_.setIcon(new Icon({
                src: icon,
            }));
        });
    };
    /**
     * Disable traffic control.
     * @override
     * @api
     */
    StreetView.prototype.disable = function () {
        if (!this.loaded_) {
            this.enableWhenLoad_ = false;
            return;
        }
        if (this.streetViewMarker_) {
            this.removeStreetViewMarker_();
        }
        this.streetViewPanorama_ = null;
        this.enabled_ = false;
        this.controlButton_.disable();
        if (this.popup_ && this.popup_.isVisible()) {
            this.popup_.hide();
        }
    };
    /**
     * Close
     * @api
     */
    StreetView.prototype.closePopup = function () {
        this.popup_.hide();
    };
    return StreetView;
}(Control));
export default StreetView;
//# sourceMappingURL=StreetView.js.map